import { render, staticRenderFns } from "./batchBidDialog.vue?vue&type=template&id=490e305a&"
import script from "./batchBidDialog.vue?vue&type=script&lang=js&"
export * from "./batchBidDialog.vue?vue&type=script&lang=js&"
import style0 from "./batchBidDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports